import { NgModule  } from '@angular/core';

import { MechanicActionsComponent } from './mechanic.actions.component';
import { SharedModule }             from '../../app-lite/shared/shared.module';

@NgModule({
    declarations: [
        MechanicActionsComponent
    ],
    entryComponents: [
        MechanicActionsComponent
    ],
    imports: [
        SharedModule
    ]
})
export class MechanicsModule {}